import queryString from "qs"
import React from "react"
import { Link, withRouter } from "react-router-dom"
import { Breadcrumb, Button, Icon } from "semantic-ui-react"
import historyStore from "stores/historyStore"
import { observer } from "mobx-react"
import shop from "shop/shop"

@withRouter
@observer
class ProductPath extends React.Component {

  getProductCategory(product) {
    let catID = "";
    for (let index in product.cats) {
      console.log(product.cats[index])
      if (catID == "") catID = product.cats[index].cat_id
      if (!isNaN(product.cats[index].cat_id)) {
        catID = product.cats[index].cat_id
      }
    }
    return catID
  }

  render() {
    const { product, path, location, useHistory, chooseCat } = this.props
    const query = queryString.parse(location.search, { ignoreQueryPrefix: true })
    let categories = shop.getCategoryPath(query.category)
    let segment = false
    if (categories) {
      segment = categories.pop()
    }

    let to = ""
    console.log("QUERY: ", query)
    if (query.referer) {
      let title = query.referrerTitle || "Zurück"
      segment = {
        title: translate(title),
        link: query.referer
      }
      to = query.referer
    }
    if (chooseCat) {
      segment = shop.getCategoryPath(chooseCat).pop()
    }
    // use the backlink from the category URL
    if (!segment && product) {
      segment = shop.getCategoryPath(this.getProductCategory(product)).pop()
    }

    if (useHistory) {
      if (historyStore.history.length > 0) {
        return <div>
          <Button basic as={Link} to={historyStore.history[0].link}><Icon
            name="chevron left" />{`${historyStore.history[0].content}`}</Button>
        </div>
      }
      return <Button onClick={() => {

      }}>{translate("Zurück")}</Button>
    }

    if (query.referrer) {
      return <Button basic as={Link} to={`${query.referrer}`}><Icon
        name="chevron left" />Suche</Button>
    }
    if (segment) {
      // SIMPLE FORWARD WITH QUERY PARAMS INCLUDED
      if (to) {
        return <div>
          <Button basic as={Link} to={to}><Icon
            name="chevron left" />{segment.title}</Button>
        </div>
      }
      //console.log("PRODUCTPATH : segment", segment)
      return (
        <div className="">
          <Breadcrumb>
            <Breadcrumb.Section link as={Link} to="/" style={{ padding: "10px" }}><Icon name="home" /></Breadcrumb.Section>
            <Breadcrumb.Divider icon="right chevron" />
            <Breadcrumb.Section active style={{ whiteSpace: "nowrap", padding: "10px" }} as={Link} to={{
              pathname: segment.link,
              search: queryString.stringify({ sort: chooseCat ? "des" : shop.config.filter_defaults.sort || "des", dir: "des", ...query })
            }}>{segment.title}</Breadcrumb.Section>
          </Breadcrumb>
          {/*<Button basic icon as={Link} to={"/"}><Icon name="home" /></Button>
          <Icon name="chevron right" />
          <Button basic as={Link} to={{
            pathname: segment.link,
            search: queryString.stringify({ sort: chooseCat ? "des" : shop.config.filter_defaults.sort || "des", dir: "des", ...query })
          }}>{segment.title}</Button>*/}
        </div>
      )
    }
    // if url AND product data fails => get parent category from historyState
    if (historyStore.history.length > 0) {
      return <div>
        <Button basic as={Link} to={historyStore.history[0].link}><Icon
          name="chevron left" />{`${historyStore.history[0].content}`}</Button>
      </div>
    } else {
      return <div>
        {/*<Breadcrumb>*/}
        {/*<Breadcrumb.Section link as={Link} to="/">Home</Breadcrumb.Section>*/}
        {/*<Breadcrumb.Divider/>*/}
        {/*{path.length > 1 &&*/}
        {/*<Breadcrumb.Section link as={Link} to={path[ 0 ].link}>{path[ 0 ].title}</Breadcrumb.Section>}*/}
        {/*{path.length > 1 && <Breadcrumb.Divider/>}*/}
        {/*<Breadcrumb.Section active style={{ whiteSpace: "nowrap" }}>{title}</Breadcrumb.Section>*/}
        {/*</Breadcrumb>*/}
        <div>
          <Button basic as={Link} to={path[0].link}><Icon name="chevron left" /> zurück zur Übersicht</Button>
        </div>
      </div>
    }
  }
}

export default ProductPath



// WEBPACK FOOTER //
// ./src/theme/mags/components/ProductPath.js